import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'file-not-found',
  templateUrl: './file-not-found.component.html',
  styleUrls: ['./file-not-found.component.scss']
})
export class FileNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
